// Folio - Portfolio Matching Platform
// Created by Anuj Kumar
// Started: January 2026

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from 'sonner';
import ProtectedRoute from './components/ProtectedRoute';

// All page imports
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Browse from './pages/Browse';
import Builder from './pages/Builder';
import MyPortfolio from './pages/MyPortfolio';
import EditPortfolio from './pages/EditPortfolio';
import Matches from './pages/Matches';
import AdminPanel from './pages/AdminPanel';
import FindPeople from './pages/FindPeople';
import PublicPortfolio from './pages/PublicPortfolio';


import '@/App.css';

// Main App component - handles all routing
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/p/:id" element={<PublicPortfolio />} />
            
            {/* Protected routes - require login */}
            <Route
              path="/find-people"
              element={
                <ProtectedRoute>
                  <FindPeople />
                </ProtectedRoute>
              }
            />
            <Route
              path="/browse"
              element={
                <ProtectedRoute>
                  <Browse />
                </ProtectedRoute>
              }
            />
            <Route
              path="/builder"
              element={
                <ProtectedRoute>
                  <Builder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-portfolio"
              element={
                <ProtectedRoute>
                  <MyPortfolio />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-portfolio"
              element={
                <ProtectedRoute>
                  <EditPortfolio />
                </ProtectedRoute>
              }
            />
            <Route
              path="/matches"
              element={
                <ProtectedRoute>
                  <Matches />
                </ProtectedRoute>
              }
            />
            
            {/* Admin only route */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
            
            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          
          {/* Toast notifications */}
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
